const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {TransitionGroup, CSSTransition} = require("react-transition-group");

const styles = require("./styles/SameHeightView.css");

module.exports = createReactClass({
	displayName: "SameHeightView",

	propTypes: {
		views: PT.arrayOf(PT.object).isRequired,
		selectedIndex: PT.number.isRequired,
		sizeClass: PT.string.isRequired,
		transitionToRight: PT.bool,
		useStaticHeight: PT.bool,
	},

	render: function() {
		const index = this.props.selectedIndex;

		const transitionRight = {
			enter: styles.rightFadeIn,
			enterActive: styles.rightFadeInActive,
			exit: styles.rightFadeOut,
			exitActive: styles.rightFadeOutActive,
		};

		const transitionLeft = {
			enter: styles.leftFadeIn,
			enterActive: styles.leftFadeInActive,
			exit: styles.leftFadeOut,
			exitActive: styles.leftFadeOutActive,
		};

		const sectionClass = styles.visibleSection;

		let heightFlex;

		if (!this.props.useStaticHeight) {
			const allSections = _.map(this.props.views, (view, i) => {
				return (
					<div
						className={styles.section + " " + this.props.sizeClass}
						key={"section" + i}
					>
						{view}
					</div>
				);
			});

			heightFlex = <div className={styles.container}>{allSections}</div>;
		}

		const transition = this.props.transitionToRight
			? transitionRight
			: transitionLeft;

		return (
			<div className={styles.main + " " + this.props.sizeClass}>
				{heightFlex}
				<TransitionGroup>
					<CSSTransition
						classNames={transition}
						timeout={{enter: 400, exit: 400}}
					>
						<div
							className={sectionClass + " " + this.props.sizeClass}
							key={"view" + index}
						>
							{this.props.views[index]}
						</div>
					</CSSTransition>
				</TransitionGroup>
			</div>
		);
	},
});
